import { render, staticRenderFns } from "./ReporteRevisionUnidadesViajePromedio.vue?vue&type=template&id=16273940&scoped=true&"
import script from "./ReporteRevisionUnidadesViajePromedio.vue?vue&type=script&lang=js&"
export * from "./ReporteRevisionUnidadesViajePromedio.vue?vue&type=script&lang=js&"
import style0 from "./ReporteRevisionUnidadesViajePromedio.vue?vue&type=style&index=0&id=16273940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16273940",
  null
  
)

export default component.exports